import { Link } from "react-router-dom";
import type { OperationEvent } from "../domain/operations";
import { eventStatusLabels } from "../domain/operations";

export function EventBadge({ event, compact = false }: { event: OperationEvent; compact?: boolean }) {
  return (
    <Link to={`/events/${event.id}`} className={`event-badge ${compact ? "compact" : ""}`}>
      <i className={`event-dot ${event.color}`} />
      {event.name}
      {!compact && <span className="event-status-chip">{eventStatusLabels[event.status]}</span>}
    </Link>
  );
}
